import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

interface LogoutButtonProps {
  isInventoryActive: boolean;
}

export const LogoutButton = ({ isInventoryActive }: LogoutButtonProps) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      toast.success("Vous avez été déconnecté avec succès");
      navigate("/");
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
      toast.error("Une erreur est survenue lors de la déconnexion");
    }
  };

  return (
    <Button
      variant="ghost"
      className={cn(
        "w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50",
        isInventoryActive && "pointer-events-none opacity-50"
      )}
      onClick={handleLogout}
      disabled={isInventoryActive}
    >
      <LogOut className="mr-3 h-5 w-5" />
      <span className="group-hover:opacity-100">Déconnexion</span>
    </Button>
  );
};